// extracted by mini-css-extract-plugin
module.exports = {"productImages":"mS0yET","borderRadiusOnHoverZoomFix":"R2ZC2N","productBadge":"ASDFqi"};